import { defineComponent } from "vue";
import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";
import TableCollaborator from "../../TableCollaborator/TableCollaborator";
import moment from "moment";
moment.locale("es");

export default defineComponent({
  name: "approval",
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    objectEdit: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data: () => ({
    showImgLeft: true,
  }),
  computed: {
    ...mapState("modCore", ["user"]),
    headerImgLeft() {
      return this.backendPath.concat(
        `/modules/permisos-sindicales/letters/societies/${this.businessPartner.society}_.png`
      );
    },
    headerImgRight() {
      return this.backendPath.concat("/modules/common/img/logo.png");
    },
    headerCaption() {
      return window.location.host || "";
    },
    backgroundImagePath() {
      return {
        backgroundImage: `url(${this.backendPath.concat(
          "/modules/common/img/logo-with-opacity.png"
        )})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 70%",
        backgroundSize: "60%",
      };
    },
    licenseEmployee() {
      const employees = [];
      if (this.getLicenseGetter.license_employees.length > 0) {
        this.getLicenseGetter.license_employees.forEach((employee) => {
          employees.push(employee);
        });
      }
      return employees;
    },
    ticketsCanBeApproved() {
      return this.getLicenseGetter
        ? !!this.getLicenseGetter.license_employees.find(
            ({ ticket, approver_id }) =>
              ticket.status === "pending" && approver_id === this.user.id
          )
        : false;
    },
    destinationCityName() {
      const { site } = this.getLicenseGetter.petitioner || {};
      return site
        ? site.city
          ? this.capitalizeText(site.city.name)
          : "<Petitioner city>"
        : "<Petitioner city>";
    },
    filingDay() {
      const me = this;
      let date = this.get_today;

      const record = me.traceabilityGetter?.data[0]?.audits?.find(
        (audit) => audit.status === "approved"
      );

      if (record) date = record?.updated_at;

      return date;
    },
    laborUnionName() {
      return this.getLicenseGetter.labor_union
        ? this.getLicenseGetter.labor_union.name
        : null;
    },
    petitioner() {
      return this.getLicenseGetter.petitioner || {};
    },
    petitionerName() {
      return this.petitioner.name || null;
    },
    petitionerRole() {
      return this.petitioner.core_role
        ? this.petitioner.core_role.name
        : "<Solicitante Sindical>";
    },
    licenseId() {
      return this.getLicenseGetter.id || null;
    },
    licenseEmployeeCount() {
      return this.getLicenseGetter.license_employees_count || 0;
    },
    licenseArrayColumn() {
      return (attribute = "", key = "") => {
        return this.getLicenseGetter[attribute]
          ? this.arrayColumn(this.getLicenseGetter[attribute], key)
          : [];
      };
    },
    allLicenseStausDays() {
      const data = this.licenseArrayColumn("license_employees", "days");
      return this.flatten(data, 'status');
    },
    isSomeDayPending() {
      return this.allLicenseStausDays.includes("pending");
    },
    flatten() {
      return (array, key = "") => {
        return this.arrayColumn(this.arrayFlat(array), key);
      };
    },
    include() {
      return (array, key = "") => {
        return array.includes(key);
      };
    },
    tickets() {
      return this.getLicenseGetter.tickets || false;
    },
    licenseEmployeeFilterDays() {
      return (state = "") => {
        return this.licenseEmployee.filter(({ days }) => {
          return days.find(({ status }) => status === state);
        });
      };
    },
    licenseEmployeeMapDays() {
      return (filter, state = "") => {
        return filter.map((result) => {
          let item = JSON.parse(JSON.stringify(result));
          item.days = result.days.filter(({ status }) => status === state);
          return item;
        });
      };
    },
    countDaysType() {
      return (array, key = "rejected") => {
        return array.reduce((count, valor) => {
          if (valor === key) return count + 1;
          return count;
        }, 0);
      };
    },
    canBeDownloaded() {
      const states = this.flatten(
        this.licenseArrayColumn("license_employees", "days"),
        "status"
      );
      const permit = ["approved", "rejected", "closed"];
      return (
        !!states.filter((item) => permit.indexOf(item) !== -1).length ||
        this.canWithCode("aprobador")
      );
    },
    getResponseTicketEventToCreate() {
      const tickets = this.licenseArrayColumn("license_employees", "ticket");
      let result = false;
      tickets.forEach(({ audits }) => {
        const response = audits.length > 0 ? audits[audits.length - 1] : false;
        result =
          response &&
          (response["event"] ?? null) === "created" &&
          (response["state"] ?? null) === "rejected";
      });
      return result;
    },
    getLastRegisterToAudit() {
      return (array) => {
        const response = array.length > 0 ? array[array.length - 1] : false;
        return response &&
          (response["event"] ?? null) === "created" &&
          (response["state"] ?? null) === "rejected"
          ? "(limite pactado en la convención colectiva de trabajo)"
          : "";
      };
    },
    businessPartner() {
      return {
        name: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.name
          : "< Business Partner >",
        role: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.core_role
            ? this.getLicenseGetter.bp.core_role.name
            : "< Business Partner >"
          : "< Business Partner >",
        society: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.society
            ? this.getLicenseGetter.bp.society.name
            : "< Bavaria >"
          : "< Bavaria >",
        signature: this.getLicenseGetter.bp
          ? this.backendPath.concat(this.getLicenseGetter.bp.signature)
          : "#",
      };
    },
    getFirstCoreEmployee() {
      return _.head(this.licenseEmployee) || {};
    },
    getDay() {
      return this.getFirstCoreEmployee.days
        ? this.getFirstCoreEmployee.days.at(-1).day
        : this.get_today;
    },
    ...mapGetters("permisosSindicalesV2License", [
      "getLicenseGetter",
      "traceabilityGetter",
      "getIsAvailableTickets",
    ]),
    /**
     * SI es editable
     */
    isEditInclude() {
      return (array = []) => {
        return array.some((value) => value !== null);
      };
    },
    isEditFilterDays() {
      return (days = "") => {
        return this.objectEdit.filter((item) => item[days] !== null);
      };
    },
    comments() {
      const result = this.getLicenseGetter.lic_comments.map(
        (comment) => comment.text
      );

      return result.join(" ");
    },
    fields() {
      const me = this;
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: me.tickets ? "Días y tiquetes aprobados" : "Días aprobados",
        },
      ];
    },
    fieldsDayNotAproval() {
      const me = this;
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: me.tickets ? "Días y tiquetes rechazados" : "Días rechazados",
        },
      ];
    },
    fieldsDayAprovalNotTickets() {
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: "Días aprobados y tiquetes rechazados",
        },
      ];
    },
    fieldsMotiveReject() {
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "motive",
          label: "Motivo del rechazo de los días de permiso",
        },
      ];
    },
    fieldsMotiveTicketReject() {
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "motive",
          label: "Motivo del rechazo de los tiquetes",
        },
      ];
    },
    items() {
      const me = this;
      let records = [];

      if (me.tickets) {
        me.fields.push(
          {
            key: "city_initial",
            label: "Desde",
          },
          {
            key: "city_final",
            label: "Hacia",
          }
        );
      } else {
        me.fields.push({
          key: "city",
          label: "Ciudad",
        });
      }

      if (me.isEdit) {
        let items = [];
        const data = me.isEditFilterDays("days_approval");
        const { ticket } = me.getFirstCoreEmployee;
        if(me.isAvailableTickets) {
          items = me.verifyApprovalTickets(data);
          items.forEach((item) => {
            if (item?.tickets?.status == "approved") {
              records.push({
                collaborator: item?.name,
                sharp_id: item?.sharp_id,
                identification: item?.cc,
                days: item?.days_approval,
                dates: null,
                ticket: {
                  type: ticket?.type?.toLowerCase(),
                  city: ticket?.origin_city?.name,
                  origin_department: ticket?.origin_city?.department_?.name,
                  destination: ticket?.destination_city_name,
                  destination_department:
                    ticket?.destination_department?.name.toLowerCase(),
                },
              });
            }
          });
        } else {
          items = data;
          items.forEach((item) => {
            records.push({
              collaborator: item?.name,
              sharp_id: item?.sharp_id,
              identification: item?.cc,
              days: item?.days_approval,
              dates: null,
              ticket: {
                type: ticket?.type?.toLowerCase(),
                city: ticket?.origin_city?.name,
                origin_department: ticket?.origin_city?.department_?.name,
                destination: ticket?.destination_city_name,
                destination_department:
                  ticket?.destination_department?.name.toLowerCase(),
              },
            });
          });
        }
      } else {
        const data = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("approved"),
          "approved"
        );

        if (me.isAvailableTickets) {
          if (me.licenseEmployeeCount > 1) {
            data.forEach((item) => {
              if (item?.ticket?.status == "approved")
                records.push(me.dataTable(item));
            });
          } else {
            if (data[0]?.ticket?.status == "approved")
              records.push(me.dataTable(data[0]));
          }
        } else {
          if (me.licenseEmployeeCount > 1) {
            data.forEach((item) => {
              records.push(me.dataTable(item));
            });
          } else {
            records.push(me.dataTable(data[0]));
          }
        }
      }
      return records;
    },
    itemsPendig() {
      const me = this;
      let records = [];

      if (me.tickets) {
        me.fields.push(
          {
            key: "city_initial",
            label: "Desde",
          },
          {
            key: "city_final",
            label: "Hacia",
          }
        );
      } else {
        me.fields.push({
          key: "city",
          label: "Ciudad",
        });
      }

      if (me.isEdit) {
        const data = me.isEditFilterDays("days_pending");
        console.log(data);
        
        const { ticket } = me.getFirstCoreEmployee;
        data.forEach((item) => {
          records.push({
            collaborator: item?.name,
            sharp_id: item?.sharp_id,
            identification: item?.cc,
            days: item?.days_rejected,
            dates: null,
            ticket: {
              type: ticket?.type?.toLowerCase(),
              city: ticket?.origin_city?.name,
              origin_department: ticket?.origin_city?.department_?.name,
              destination: ticket?.destination_city_name,
              destination_department:
                ticket?.destination_department?.name.toLowerCase(),
            },
          });
        });
      } else {
        const data = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("pending"),
          "pending"
        );
        if (me.licenseEmployeeCount > 1) {
          data.forEach((item) => {
            records.push(me.dataTable(item));
          });
        } else {
          records.push(me.dataTable(data[0]));
        }
      }
      return records;
    },
    itemsDayApprovalNotTickets() {
      const me = this;
      let records = [];
      me.fieldsDayAprovalNotTickets.push(
        {
          key: "city_initial",
          label: "Desde",
        },
        {
          key: "city_final",
          label: "Hacia",
        }
        );

      if (me.isEdit) {
        const data = me.isEditFilterDays("days_approval");
        const items = me.verifyApprovalTickets(data);

        const { ticket } = me.getFirstCoreEmployee;
        items.forEach((item) => {
          if (item?.tickets?.status == "rejected" || item?.tickets?.status == "not_available") {
            records.push({
              collaborator: item?.name,
              sharp_id: item?.sharp_id,
              identification: item?.cc,
              days: item?.days_approval,
              dates: null,
              ticket: {
                type: ticket?.type?.toLowerCase(),
                city: ticket?.origin_city?.name,
                origin_department: ticket?.origin_city?.department_?.name,
                destination: ticket?.destination_city_name,
                destination_department:
                  ticket?.destination_department?.name.toLowerCase(),
              },
            });
          }
        });
      } else {
        const data = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("approved"),
          "approved"
        );

        if (me.licenseEmployeeCount > 1) {
          data.forEach((item) => {
            if (item?.ticket?.status == "rejected" || item?.ticket?.status == "not_available")
              records.push(me.dataTable(item));
          });
        } else {
          if (data[0]?.ticket?.status == "rejected" || data[0]?.ticket?.status == "not_available")
            records.push(me.dataTable(data[0]));
        }
      }
      return records;
    },
    itemsRejected() {
      const me = this;
      let records = [];

      if (me.tickets) {
        me.fields.push(
          {
            key: "city_initial",
            label: "Desde",
          },
          {
            key: "city_final",
            label: "Hacia",
          }
        );
      } else {
        me.fields.push({
          key: "city",
          label: "Ciudad",
        });
      }

      if (me.isEdit) {
        const data = me.isEditFilterDays("days_rejected");

        const { ticket } = me.getFirstCoreEmployee;
        data.forEach((item) => {
          records.push({
            collaborator: item?.name,
            sharp_id: item?.sharp_id,
            identification: item?.cc,
            days: item?.days_rejected,
            dates: null,
            ticket: {
              type: ticket?.type?.toLowerCase(),
              city: ticket?.origin_city?.name,
              origin_department: ticket?.origin_city?.department_?.name,
              destination: ticket?.destination_city_name,
              destination_department:
                ticket?.destination_department?.name.toLowerCase(),
            },
          });
        });
      } else {
        const data = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("rejected"),
          "rejected"
        );
        if (me.licenseEmployeeCount > 1) {
          data.forEach((item) => {
            records.push(me.dataTable(item));
          });
        } else {
          records.push(me.dataTable(data[0]));
        }
      }
      return records;
    },
    itemsMotiveRejected() {
      const me = this;
      let records = [];

      if (me.isEdit) {
        const data = me.isEditFilterDays("days_rejected");

        data?.forEach((item) => {
          records.push({
            collaborator: item?.name,
            motive: item?.reason,
          });
        });
      } else {
        const data = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("rejected"),
          "rejected"
        );

        data?.forEach((item) => {
          records.push({
            collaborator: item?.core_employee?.name,
            motive: item?.reason,
          });
        });
      }

      return records;
    },
    itemsMotiveTicketRejected() {
      const me = this;
      let records = [];

      if (me.isEdit) {
        const data = me.isEditFilterDays("days_approval");
        const items = me.verifyApprovalTickets(data);

        items?.forEach((item) => {
          if (item?.tickets?.status == "rejected" || item?.tickets?.status == "not_available") {
            records.push({
              collaborator: item?.tickets?.name,
              motive: item?.tickets?.reason,
            });
          }
        });
      } else {
        const dataApproved = me.licenseEmployeeMapDays(
          me.licenseEmployeeFilterDays("approved"),
          "approved");

        dataApproved?.forEach((item) => {
          if (item?.ticket?.status == "rejected" || item?.ticket?.status == "not_available") {
            records.push({
              collaborator: item?.core_employee?.name,
              motive: item?.ticket?.reason ? item?.ticket?.reason : "Rechazado por límite de tiquetes.",
            });
          }
        });
      }

      return records;
    },
    commentsEdit() {
      const me = this;
      const comments = me.arrayColumn(me.objectEdit, "comments");
      return comments.length > 0 ? comments[0].toLowerCase() : "";
    },
    isAvailableTickets() {
      const me = this;
      return me.tickets;
    },
    isMessageTicketNotAvailable() {
      const me = this;
      const record = me.licenseEmployee?.find(
        (item) => item?.ticket?.status !== "not_available"
      )
      return record ? false : true
    }
  },
  methods: {
    ...mapActions("permisosSindicalesV2License", ["getTraceabilityAction"]),
    handleImgErrorLeft() {
      this.showImgLeft = false;
    },
    daysOrderMonth(items) {
      let days = [];
      items?.forEach((day) => {
        const month = moment(day?.day).format("MMMM");
        const record = days.find((item) => item.month === month);
        if (record) {
          record.dates.push(day?.day);
        } else {
          days.push({
            month: month,
            dates: [day?.day],
          });
        }
      });
      return days;
    },
    dataTable(data) {
      const me = this;
      return {
        collaborator: data?.core_employee?.name,
        sharp_id: data?.core_employee?.sharp_id,
        identification: data?.core_employee?.cc,
        dates: me.daysOrderMonth(data?.days),
        ticket: {
          type: data?.ticket?.type?.toLowerCase(),
          city: data?.ticket?.origin_city?.name,
          origin_department: data?.ticket?.origin_city?.department_?.name,
          destination: data?.ticket?.destination_city_name,
          destination_department:
            data?.ticket?.destination_department?.name.toLowerCase(),
        },
      };
    },
    verifyApprovalTickets(data) {
      const records  = []
      const ticketsApprobals = data[0]?.ticketsApprobals;

      data.forEach((item) => {
        const tickets = ticketsApprobals.find((ticket) => ticket?.sharp_id == item?.sharp_id);
        records.push({
          ...item,
          tickets,
        })
      })

      return records;
    }
  },
  components: {
    TableCollaborator,
  },
  // async beforeMount () {
  //   await this.getTraceabilityAction({ id: this.licenseId })
  // }
});
